import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './Navigation.css';

function Navigation() {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const checkIfMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        };
        setIsMobileDevice(checkIfMobile());
    }, []);

    const links = [
        { to: '/swap', label: t('tokenSwap'), icon: '🔄' },
        { to: '/trx-usdt', label: t('trxUsdtSwap'), icon: '💱' },
        { to: '/energy', label: t('energyExchange'), icon: '⚡' },
        { to: '/payment', label: t('benefits'), icon: '🎁' }
    ];

    // 动画变体
    const navVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 25
            }
        }
    };

    const menuItemVariants = {
        closed: { opacity: 0, y: -10 },
        open: { 
            opacity: 1, 
            y: 0,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 15
            }
        }
    };

    return (
        <motion.nav 
            className="main-navigation"
            variants={navVariants}
            initial="hidden"
            animate="visible"
        >
            <div className="nav-container">
                <div className="left-nav-items">
                    <Link to="/" className="logo">
                        <span>{t('siteTitle')}</span>
                    </Link>
                </div>

                {/* 桌面版菜单 - 只在非移动设备上显示 */}
                {!isMobileDevice && (
                    <div className="desktop-menu">
                        {links.map(link => (
                            <Link 
                                key={link.to}
                                to={link.to}
                                className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
                            >
                                <span className="nav-icon">{link.icon}</span>
                                <span className="nav-label">{link.label}</span>
                                {location.pathname === link.to && (
                                    <motion.div 
                                        className="active-indicator"
                                        layoutId="activeIndicator"
                                        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                                    />
                                )}
                            </Link>
                        ))}
                    </div>
                )}

                {/* 在非移动设备上显示汉堡菜单按钮 */}
                {!isMobileDevice && (
                    <button 
                        className="mobile-menu-toggle"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label={isMobileMenuOpen ? t('closeMenu') : t('openMenu')}
                    >
                        <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                )}
            </div>

            {/* 移动设备上的导航菜单 - 直接显示功能选项 */}
            {isMobileDevice && (
                <div className="mobile-menu-always-visible">
                    {links.map(link => (
                        <Link 
                            key={link.to}
                            to={link.to}
                            className={`mobile-nav-link ${location.pathname === link.to ? 'active' : ''}`}
                        >
                            <span className="nav-icon">{link.icon}</span>
                            <span className="nav-label">{link.label}</span>
                        </Link>
                    ))}
                </div>
            )}

            {/* 非移动设备上的折叠菜单 */}
            <AnimatePresence>
                {!isMobileDevice && isMobileMenuOpen && (
                    <motion.div 
                        className="mobile-menu"
                        initial="closed"
                        animate="open"
                        exit="closed"
                    >
                        {links.map(link => (
                            <motion.div
                                key={link.to}
                                variants={menuItemVariants}
                                whileHover={{ backgroundColor: 'rgba(52, 152, 219, 0.05)' }}
                            >
                                <Link 
                                    to={link.to}
                                    className={`mobile-nav-link ${location.pathname === link.to ? 'active' : ''}`}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    <span className="nav-icon">{link.icon}</span>
                                    <span className="nav-label">{link.label}</span>
                                </Link>
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.nav>
    );
}

export default Navigation; 